export { default as getLanguageFromStorage } from "./getLanguageFromStorage";
